import request from "~/utils/http";

const supplierApi =
{
	get : async (id) =>
	{
		const url = `supplier/detail/${id}`;
		return await request.get(url);
	},
	gets : async (params) =>
	{
		const url = 'supplier';
		return await request.get(url, {params});
	},
	options : async (params) =>
	{
		const url = 'supplier';
        const paramsWidthOption = {
            ...params,
            options: true,
        };
        return await request.get(url, {paramsWidthOption});
	},
	add : async (params) =>
	{
		const url = 'supplier';
		return await request.post(url, params);
	},
	update : async (params) =>
	{
		const url = `supplier/${params.id}`;
		return await request.post(url, params);
	},
	delete : async (id) =>
	{
		const url = `supplier/${id}`;
		return await request.delete(url);
	},
};

export default supplierApi;